<style scoped>
  .refr {
    cursor: pointer;
    color: var(--color-text-dark);
  }

  .off {
    color: var(--color-neutral);
  }
</style>

<template>
  <div style="font-weight: normal">
    <Tooltip max-width="300" :delay="1000" placement="top" :content="$text.tr('Обновить баланс')">
      <Icon :class="{refr: active, off: !active}" size="28" type="ios-refresh" @click="clicked" />
    </Tooltip>
  </div>
</template>

<script>
import terminal from '@/services/terminal'
export default {
  name: 'MiniAssetRefresher',
  data () {
    return {
      active: true
    }
  },
  methods: {
    clicked () {
      if (this.active) {
        this.active = false

        terminal.UpdateBalance().then(response => {
          this.$store.dispatch('updateAssets')
          this.$store.dispatch('updateAssetBalance')
        }).catch(function (error) {
          console.log(error)
        })

        setTimeout(() => {
          this.active = true
        }, 10 * 1000)
      }
    }
  }
}
</script>
